/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";
import { ResponsiveBar } from "@nivo/bar";

const colors = [
  "#9CA4F0",
  "#EF81B0",
  "#FF8E8E",
  "#FAD77F",
  "#63B58E",
  "#6ABED0",
  "#5AA3CD",
  "#F29fd6",
  "#Ef81b0",
  "#ffc1c1",
  "#FF8E8E",
  "#F8E9B7",
  "#FAD77F",
  "#96DFBC",
  "#64B696",
  "#B6E670",
  "#6ABED0",
  "#84D6E7",
  "#5AA3CD",
].reverse();

const Graph = ({ data, keys, totalByKeys }) => {
  return (
    <div
      style={{
        position: "relative",
        backgroundColor: "#fff",
        width: "100%",
        height: 500,
        border: "1px solid #ddd",
        borderRadius: 2,
        position: "relative",
      }}
    >
      <ResponsiveBar
        data={data}
        keys={keys}
        indexBy="mfr"
        margin={{ top: 50, right: 130, bottom: 60, left: 60 }}
        padding={0.3}
        colors={(value) => {
          return colors[keys.indexOf(value.id) % colors.length];
          return "#f00";
        }}
        defs={[
          {
            id: "dots",
            type: "patternDots",
            background: "inherit",
            color: "#38bcb2",
            size: 4,
            padding: 1,
            stagger: true,
          },
          {
            id: "lines",
            type: "patternLines",
            background: "inherit",
            color: "#eed312",
            rotation: -45,
            lineWidth: 6,
            spacing: 10,
          },
        ]}
        borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        axisTop={{
          tickSize: 0,
          legendOffset: -20,
          legend: "Device Population",
          legendPosition: "middle",
          format: () => null,
        }}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "Total (" + data.map((d) => d.total).reduce((a, b) => a + b, 0) + ")",
          legendPosition: "middle",
          legendOffset: 40,
          format: (val) => {
            const d = data[data.map((d) => d.mfr).indexOf(val)] || {};
            const total = d.total || 0;
            return val + " (" + total + ")";
          },
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          // legend: 'food',
          legendPosition: "middle",
          legendOffset: -40,
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        animate={true}
        motionStiffness={90}
        motionDamping={15}
      />
      <div style={{ position: "absolute", bottom: 45, right: 20, display: "flex", flexDirection: "column" }}>
        {keys.map((key, index) => {
          return (
            <div style={{ display: "flex", alignItems: "center", marginBottom: 3 }}>
              <div
                style={{
                  width: 15,
                  height: 10,
                  backgroundColor: colors[index % colors.length],
                  marginRight: 5,
                }}
              />
              <small key={key}>
                {key} {`(${totalByKeys[key] || 0})`}
              </small>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Graph;
